export default __webpack_public_path__ + "static/media/logo.3d93fbe4.png";